import { makeStyles } from "@material-ui/core";

export const workoutStyles = makeStyles((theme) => ({
  question: {
    color: "#000000",
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: theme.typography.pxToRem(22),
  },
  answerContainer: {
    margin: "20px 0px 0px 20px",
    "& .MuiIconButton-root": {
      color: "black",
    },
    "& .MuiTypography-root": {
      color: "#000000",
      fontFamily: "Inter",
      fontWeight: 400,
      fontSize: theme.typography.pxToRem(16),
    },
  },
  desabledOption: {
    "& .Mui-disabled": {
      color: "#666666",
    },
  },
}));
